import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import './assets/tailwind.css'
import VueCookies from 'vue-cookies';
import store from './store'




createApp(App)
  .use(VueCookies)
  .use(router)
  .use(store)
  
  .mount('#app')
 